<div class="services-section-container">
  <div class="services-title">
    ЦЕЛИ
  </div>
  <div class="service-content">
    <div class="service-content-container">
      <div *ngFor="let card of firstArray">
        <div class="service-content-el">
          <div class="service-content-el-top">
            <div class="service-content-el-top-icon">
              <app-icon [icon]="card.icon"/>
            </div>
          </div>
          <div class="service-content-el-mid">
            {{ card.title }}
          </div>
          <div class="service-content-el-bot">
            {{ card.text }}
          </div>
        </div>
      </div>
    </div>
    <div class="service-content-container">
      <div *ngFor="let card of secondArray">
        <div class="service-content-el">
          <div class="service-content-el-top">
            <div class="service-content-el-top-icon">
              <app-icon [icon]="card.icon"/>
            </div>
          </div>
          <div class="service-content-el-mid">
            {{ card.title }}
          </div>
          <div class="service-content-el-bot">
            {{ card.text }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
